// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"2274bbab0116a3352119","532":"d4b83741a472a21eacb3","691":"d62bdf504892b734ecd8"}[chunkId] + ".js";
};